import { styled } from '@mui/material/styles';

const BoxContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '40%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  background: theme.palette.common.white,
  borderRadius: '12px',
  marginTop: theme.spacing(2),
  padding: theme.spacing(4),
  [theme.breakpoints.down('xl')]: {
    width: '55%',
  },
  [theme.breakpoints.down('lg')]: {
    width: '60%',
  },
  [theme.breakpoints.down('md')]: {
    width: '80%',
  },
  [theme.breakpoints.down('sm')]: {
    width: '90%',
  },
}));

const RulesText = styled('p')(({ theme }) => ({
  color: '#354661',
  fontSize: '19px',
  [theme.breakpoints.down('md')]: {
    fontSize: '1rem',
  },
}));

const DescriptionComponent = () => {
  return (
    <BoxContainer>
      <RulesText className="typography-v1-legacy-p1">
        Vi mener at alle bør sjekke om de kan få lavere rente på sine forbrukslån og kredittkort.
        <br />
        <br />
        I 2023 hjalp vi ti-tusenvis av nordmenn med å få lavere rente, og sammen klarte vi å kutte
        rentekostnadene med 250 millioner kroner!
        <br />
        <br />
        Vi vet at enda flere kan få lavere rente. Derfor ønsker vi nå å rette fokus mot Gjeldvett
        slik at enda flere blir oppmerksom på å senke renten der de kan.
        <br />
        <strong>Det er vel ikke vits å betale mere enn man må?</strong>
      </RulesText>
    </BoxContainer>
  );
};

export default DescriptionComponent;
